/** Превращает плоский список групп товаров в дерево (по parentid) */
export const transformItemsGroup = (itemGroups) => {
  const groupMap = {};

  for (const group of itemGroups) {
    groupMap[group.itemgroupid] = { ...group, children: [] };
  }

  const sorted = [...itemGroups].sort((a, b) =>
    Number(a.position) > Number(b.position) ? 1 : -1
  );

  const rootGroups = [];

  for (const group of sorted) {
    if (String(group.parentid) === "0") {
      rootGroups.push(groupMap[group.itemgroupid]);
    } else {
      const parentGroup = groupMap[group.parentid];
      if (parentGroup) {
        parentGroup.children.push(groupMap[group.itemgroupid]);
      } else {
        rootGroups.push(groupMap[group.itemgroupid]);
      }
    }
  }

  return rootGroups;
};

/** Все id потомков указанных групп (рекурсивно) */
export const findGroupsAllChildrenIds = (allGroups, groupIds) => {
  const parents = new Set(groupIds.map(String));
  const childrenIds = allGroups
    .filter((g) => parents.has(String(g.parentid)))
    .map((g) => g.itemgroupid);

  if (!childrenIds.length) return [];

  return [...childrenIds, ...findGroupsAllChildrenIds(allGroups, childrenIds)];
};
